import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import {inject, ViewEncapsulation,ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { AppComponent } from 'src/app/app.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  c_p_hide: boolean = true;
  p_hide: boolean = true;
  n_P_hide:boolean=true;
  imageChangedEvent: Event | null = null;
  croppedImage: string = '';
  profileImage: string = '';
  dropboxLinks: string[] = [];
  showPasswordDetails: boolean = false;
  OldPassword = new FormControl();
  Password = new FormControl('', [Validators.required]);
  confirmPassword = new FormControl('', [Validators.required]);
  showOldPassword:boolean=false;
  showNewPassword:boolean=false;
  showConfirmPassword:boolean=false;
  FirstName = new FormControl('', [Validators.required]);
  LastName = new FormControl('', [Validators.required]);
  MobileNumber = new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$")]);
  AddressLineOne = new FormControl('', [Validators.required]);
  AddressLineTwo = new FormControl('', [Validators.required]);
  City = new FormControl('', [Validators.required]);
  State = new FormControl('', [Validators.required]);
  Pincode = new FormControl('', [Validators.required, Validators.pattern("^[0-9]{6}$")]);
  UserId: string = "";
  selectedFile: File | null = null;
  totalFields: number = 9;
  accounttype : string = "";
  email: string = '';
  mobileNumber: string = '';
  completedFields: number = 0;
  profileForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    mobile: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
  });
  
  get emailControl() {
    return this.profileForm.get('email');
  }
  
  get mobileControl() {
    return this.profileForm.get('mobile');
  }
  

  constructor(public dialog: MatDialog, 
    private http: HttpClient,
    public service: SharkifyAiSerivceService,
    public app: AppComponent,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef
  ) {}
  @ViewChild('fileInput') fileInput: ElementRef | undefined; // Add this inside the class

  triggerFileInput() {
     if (this.fileInput) {
    this.fileInput.nativeElement.click();
  } else {
    console.error('File input is not available');
  }
  }
  

  ngOnInit() {
    const formFields: NodeListOf<HTMLInputElement | HTMLSelectElement> = document.querySelectorAll('#profileForm input, #profileForm select');
    formFields.forEach(field => {
      field.addEventListener('input', () => this.updateProgress(formFields));
    });
    this.UserId = this.getSafeValue(localStorage.getItem("UserId"));
    this.accounttype = this.getSafeValue(localStorage.getItem("AccountType"));
  }

  getSafeValue(value: string | null): string {
    return value === null || value === "undefined" ? "" : value;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input && input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.imageChangedEvent = event;
    }
  }

  sendEmailVerification(type: string): void {
    const dialogData = { type,email: this.email };
    const dialogRef = this.dialog.open(EmailOtpDialog, {
      height: 'auto',
      width: '400px',
      data: dialogData,
    });
    console.log(this.email)
        this.service.createVerification(this.email, this.UserId).subscribe(
          
          (response) => {
            this.toastr.success('Verification code sent successfully!', 'Success');
          },
          (error) => {
            this.toastr.error('Failed to send verification code', 'Error');
            console.error('Error sending verification code:', error);
          }
        );
  }
  
  sendMobileVerification(type : string){
    const dialogData = { type,mobileNumber: this.mobileNumber };
    const dialogRef = this.dialog.open(EmailOtpDialog,{
        height:'auto',
        width:'400px',
        data:dialogData,
    });
        this.service.createVerification(this.mobileNumber, this.UserId).subscribe(
          
          (response) => {
            this.toastr.success('Verification code sent successfully!', 'Success');
          },
          (error) => {
            this.toastr.error('Failed to send verification code', 'Error');
            console.error('Error sending verification code:', error);
          }
        );
  }
  updateProfile() {
    this.app.displayLoader(true);
    if (this.isProfileFormValid()) {
      this.service.UpdateClientProfileDetails(
        this.UserId,
        this.FirstName.value || '',
        this.LastName.value || '',
        this.MobileNumber.value || '',
        this.AddressLineOne.value || '',
        this.AddressLineTwo.value || '',
        this.City.value || '',
        this.State.value || '',
        this.Pincode.value || ''
      ).subscribe(data => {
        this.app.displayLoader(false);
        this.toastr.success('Details successfully uploaded', 'Success');
      }, error => {
        this.toastr.error('Please fill in the complete details', 'Error');
      });
    } else {
      this.app.displayLoader(false);
      this.toastr.error('Please fill in the complete details', 'Error');
    }
  }

  isProfileFormValid(): boolean {
    return this.FirstName.valid && this.LastName.valid &&
           this.MobileNumber.valid && this.AddressLineOne.valid &&
           this.AddressLineTwo.valid && this.City.valid &&
           this.State.valid && this.Pincode.valid;

  }
  updateProgress(fields: NodeListOf<HTMLInputElement | HTMLSelectElement>) {
    this.completedFields = Array.from(fields).filter(field => field.value.trim() !== '').length;
    const completionPercentage = Math.round((this.completedFields / this.totalFields) * 100);
    const progressFill = document.getElementById('progressFill') as HTMLElement;
    const progressPercent = document.getElementById('progressPercent') as HTMLElement;

    progressFill.style.width = `${completionPercentage}%`;
    progressPercent.textContent = `${completionPercentage}%`;

    if (completionPercentage === 100) {
      progressFill.style.backgroundColor = 'green';
      progressPercent.classList.add('complete');
    } else {
      progressFill.style.backgroundColor = 'orange';
      progressPercent.classList.remove('complete');
    }
  }

  togglePasswordVisibility(field: string) {
    this.showPasswordDetails = !this.showPasswordDetails;
  }

  passwordsMatch(): boolean {
    return this.Password.value === this.confirmPassword.value;
  }

  // fileChangeEvent(event: any): void {
  //   this.imageChangedEvent = event;
  // }
  imageLoaded(image: LoadedImage) {
  }
  cropperReady() {
  }

  loadImageFailed() {
    console.error('Image loading failed.');
  }


  imageCropped(event: ImageCroppedEvent) {
    const objectUrl = event.objectUrl ?? event.base64;
    if (objectUrl) {
      this.convertToBase64(objectUrl).then((base64: string) => {
        this.croppedImage = base64;
      });
    }
  }

  uploadFile(event: Event): void {
    this.app.displayLoader(true);
    event.preventDefault();

    if (this.croppedImage) {
      const formData = new FormData();
      formData.append('folderName','Sharkify')
      formData.append('userId','Client '+ this.UserId)
      formData.append('folderType','Profile')
      // formData.append('file',this.croppedImage);
      
      formData.append('file',this.base64ToBlob(this.croppedImage), `profile.png`);
      this.service.UpdateClientProfilePhoto(formData, this.UserId).subscribe(
        (response) => {
          
          if (response) {
            this.profileImage = response.data.Image
            console.log("this is the picture",this.profileImage)
            this.cd.detectChanges();
            this.service.updateUser(this.UserId, this.profileImage ).subscribe(
              (updateResponse) => {
                this.toastr.success('User Image uploaded and profile updated successfully!', 'Success');
              },
              (error) => {
                this.toastr.error('Error updating user profile', 'Error');
                console.error('Error updating user profile:', error);
              }
            );
          }
          this.app.displayLoader(false);
        },
        (error) => {
          this.app.displayLoader(false);
          this.toastr.error('Error uploading file', 'Error');
          console.error('Error uploading file:', error);
        }
      );
    } else {
      this.toastr.error('Please fill in all required fields correctly.', 'Error');
      this.app.displayLoader(false);
      console.warn('No file or cropped image available for upload.');
    }
  }

  convertToBase64(objectUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', objectUrl, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status === 200) {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.readAsDataURL(xhr.response);
        } else {
          reject(new Error('Failed to convert object URL to base64.'));
        }
      };
      xhr.onerror = () => reject(new Error('Failed to convert object URL to base64.'));
      xhr.send();
    });
  }
  base64ToBlob(base64: string): Blob {
    const byteString = atob(base64.split(',')[1]);
    const mimeString = base64.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }


  profileUpdatePassword() {
    this.app.displayLoader(true);
    if (this.OldPassword.value !== this.Password.value) {
      if (this.Password.value === this.confirmPassword.value) {
        this.service.UpdateClientProfilePassword(this.UserId, this.OldPassword.value, this.Password.value+"").subscribe(data => {
          this.app.displayLoader(false);
            this.toastr.success('Password Updated Successfully', 'Success');
        }, error => {
          this.toastr.error('Password update failed', 'Error');
        });
      } else {
        this.toastr.error('Passwords do not match', 'Error');
        this.app.displayLoader(false);
      }
    } else {
      this.toastr.error('Old Password and New Password cannot be the same', 'Error');
      this.app.displayLoader(false);
    }
  }
}

@Component({
  selector : 'app-email-otp-dialog',
  templateUrl : './email-otp-dialog.html',
  styleUrls : ['./email-otp-dialog.css'],
  encapsulation : ViewEncapsulation.None 
})
export class EmailOtpDialog{  
  constructor(public dialogref: MatDialogRef<EmailOtpDialog>,private toastr: ToastrService,public service:SharkifyAiSerivceService,@Inject(MAT_DIALOG_DATA) public data: any,){} 
  c_p_hide: boolean = true;
  p_hide: boolean = true;
  enteremail: boolean = true;
  enterotp: boolean = false;
  errorMessage: string = '';
  changepassword: boolean = false;
  code: string[] = ['', '', '', ''];
  focusNext(event: KeyboardEvent, nextInputIndex: number): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length > 0) {
      const nextInput = input.parentElement?.querySelector(`input:nth-child(${nextInputIndex + 1})`) as HTMLInputElement;
      nextInput?.focus();
    }
  }
    
  verifyCode(): void {
    const enteredCode = this.code.join('').trim(); // Combine OTP inputs into a single string
    console.log('entered Code:', enteredCode);
    if (enteredCode.length !== 4) {
      this.toastr.error('Please enter a valid 4-digit code.', 'Error');
      return;
    }
  
    this.service.verifyOtp(this.data.email, enteredCode).subscribe(
      (response) => {
        console.log('Response:', response);
  
        // Handle success based on backend response
        if (response.Status === 'Active') {
          this.toastr.success('Verification successful!', 'Success');
          this.dialogref.close(true); // Close dialog on success
        } else {
          this.toastr.error('Invalid verification code.', 'Error');
          this.errorMessage = 'The code you entered is incorrect.';
        }
      },
      (error) => {
        console.error('Verification error:', error);
        this.toastr.error('Verification failed. Please try again.', 'Error');
        this.errorMessage = error?.error?.message || 'An error occurred.';
      }
    );
  }
  
  
  
  closeDialog() {
    this.dialogref.close()
  }
  ngOnInit(): void {
  
  }
}